import {getFormattedDate, getFormattedDateUserReadable} from "../../utils/getFormattedDate";
import * as React from "react";

interface IProps {
    date: any;
}

export function DateLastChanged ({date}: IProps) {
    return <><strong>Date Last Changed: </strong>{getFormattedDateUserReadable(date)} ({getFormattedDate(date)})</>
}